import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete,
  apiFile
} from "../../../../shared/services";

const fetchItems = async (options, cancelToken) => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options, cancelToken });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const exportBrandschutz = async data => {
  const url = apiConstants.url;
  return await apiFile(url + "/exportbrandschutz", { ...data });
};

export { fetchItems, saveItem, deleteItem, fetchItem, exportBrandschutz };
